const ready = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};

const slugify = (value) =>
  value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

const showStoreReviewsOnly = () => {
  if (!document.body.matches('.template-collection')) return;

  const mainContent = document.getElementById('MainContent') || document.body;
  let observer;

  const activateStoreReviews = () => {
    const widget = document.querySelector('.cactus-store-reviews');
    if (!widget) return false;

    const storeReviewsTab = widget.querySelector('[data-tabname="shop-reviews"]');
    const modernWidget = widget.querySelector('.jdgm-all-reviews-widget-v2025');

    widget.classList.add('cactus-store-reviews-only');
    modernWidget?.setAttribute('data-review-source', 'store');

    if (!storeReviewsTab) return false;

    for (const node of storeReviewsTab.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('Shop Reviews')) {
        node.textContent = node.textContent.replace('Shop Reviews', 'Store reviews');
      }
    }

    if (!storeReviewsTab.classList.contains('jdgm--active')) storeReviewsTab.click();

    return storeReviewsTab.classList.contains('jdgm--active');
  };

  if (activateStoreReviews()) return;

  observer = new MutationObserver(() => {
    if (!activateStoreReviews()) return;
    observer.disconnect();
  });

  observer.observe(mainContent, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 10000);
};

ready(() => {
  document.querySelectorAll('h1, h2, h3, h4').forEach((heading) => {
    if (!heading.textContent.trim()) heading.remove();
  });

  showStoreReviewsOnly();

  if (!document.body.matches('.page-handle-privacy-policy, .page-handle-terms-conditions')) return;

  const content = document.querySelector('.page-width-content rte-formatter');
  if (!content || content.querySelector('.cactus-policy-toc')) return;

  const headings = [...content.querySelectorAll('h2, h3, h4')].filter((heading) => heading.textContent.trim());
  if (headings.length < 2) return;

  const nav = document.createElement('nav');
  nav.className = 'cactus-policy-toc';
  nav.setAttribute('aria-label', 'On this page');

  const label = document.createElement('p');
  label.className = 'cactus-policy-toc__label';
  label.textContent = 'On this page';

  const links = document.createElement('div');
  links.className = 'cactus-policy-toc__links';

  headings.forEach((heading, index) => {
    const id = heading.id || slugify(heading.textContent) || `section-${index + 1}`;
    heading.id = id;

    const link = document.createElement('a');
    link.href = `#${id}`;
    link.textContent = heading.textContent.trim();
    links.append(link);
  });

  nav.append(label, links);
  content.prepend(nav);
});
